// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32c6e","type":"styles_type__WxrdY","choices":"styles_choices__4vFZ0"};